<template>
  <div class="notice-manage-container">
    <!-- 查询条件 -->
    <el-card class="search-wrapper">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('member.search.title') }}</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input v-model="searchForm.title" :placeholder="$t('member.search.titlePlaceholder')" />
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="handleSearch">
            {{ $t('common.search') }}
          </el-button>
          <el-button @click="handleReset">
            {{ $t('common.reset') }}
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="list-wrapper">
      <div slot="header" class="flex justify-between">
        <span>楼长列表</span>
        <el-button type="primary" size="small" style="float:right" @click="handleAdd">
          {{ $t('common.add') }}
        </el-button>
      </div>

      <el-table v-loading="loading" :data="tableData" border style="width:100%">
        <el-table-column prop="name" label="姓名" align="center" />
        <el-table-column prop="gender" label="性别" align="center" />
        <el-table-column prop="gender" label="所属楼栋" align="center" />
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)">
              {{ $t('common.edit') }}
            </el-button>
            <el-button v-if="scope.row.state !== '2000'" size="mini" type="danger" @click="handleDelete(scope.row)">
              {{ $t('common.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page="pagination.current" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.size"
        :total="pagination.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </el-card>

    <!-- 删除确认对话框 -->
    <delete-notice ref="deleteNotice" @success="handleSuccess" />
    <edit-declaration ref="editDeclaration" @success="handleSuccess" />
    <add-declaration ref="addDeclaration" @success="handleSuccess" />
    <add-master ref="addMaster" @success="handleSuccess" />
    <delete-master ref="deleteMaster" @success="handleSuccess" />
    <edit-master ref="editMaster" @success="handleSuccess" />
  </div>
</template>

<script>
import { listQuarter } from '@/api/oa/noticeManageApi'
import DeleteNotice from '@/components/oa/deleteMember'
import { getCommunityId } from '@/api/community/communityApi'
import AddDeclaration from '@/components/oa/AddPet'
import addMaster from './addMaster.vue'
import deleteMaster from './deleteMaster.vue'
import EditDeclaration from '@/components/oa/editMember'

import EditMaster from './editMaster.vue'




export default {
  name: 'propertyAccountList',
  components: {
    DeleteNotice,
    AddDeclaration,
    addMaster,
    deleteMaster,
    EditMaster,
    EditDeclaration,  
  },
  data() {
    return {
      loading: false,
      searchForm: {
        title: '',
        noticeTypeCd: '',
        state: '',
        startTime: '',
        endTime: ''
      },
      tableData: [{
        name: '张三',
        gender: '男',
        building: '1号楼',
        room: '101',
        phone: '12345678901',
        state: '正常'
      }],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    // this.getList()
  },
  methods: {
    async getList() {
      try {
        this.loading = true
        const params = {
          page: this.pagination.current,
          row: this.pagination.size,
          ...this.searchForm,
          communityId: this.communityId
        }
        const { notices, total } = await listQuarter(params)
        this.tableData = notices
        this.pagination.total = total
      } catch (error) {
        this.$message.error(this.$t('quarterFinance.fetchError'))
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.current = 1
      this.getList()
    },
    handleReset() {
      this.searchForm = {
        title: '',
        noticeTypeCd: '',
        state: '',
        startTime: '',
        endTime: ''
      }
      this.getList()
    },
    handleAdd() {
      this.$refs.addMaster.open()
    },
    handleEdit(row) {
      this.$refs.editMaster.open(row)
    },
    handleDelete(row) {
      this.$refs.deleteMaster.open(row)
    },
    handleSuccess() {
      this.getList()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-manage-container {
  padding: 20px;

  .search-wrapper {
    margin-bottom: 20px;

    .el-row {
      margin-bottom: 20px;
    }
  }

  .list-wrapper {
    .el-pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>